var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Lib from "@core/libs";
var TCAttachmentUpload = /** @class */ (function (_super) {
    __extends(TCAttachmentUpload, _super);
    function TCAttachmentUpload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TCAttachmentUpload.prototype.onMounted = function () {
        var _this = this;
        this.modal = this.el.querySelector('#attachment-upload-modal');
        this.uploadForm = this.el.querySelector('form');
        this.fileField = this.el.querySelector('input[type="file"]');
        this.nameField = this.el.querySelector('input[name="name"]');
        this.modalForm = this.el.querySelector('#attachment-modal-form');
        this.modalSubmitButton = this.el.querySelector('#modal-submit');
        this.modalNameField = this.el.querySelector('#attachment-filename');
        this.fileField.addEventListener('change', function () { return _this.onFileSelected(); });
        this.modalForm.addEventListener('submit', function (event) {
            event.preventDefault();
            _this.onModalFormSubmit();
        });
        this.el.querySelectorAll('button[type="reset"]').forEach(function (button) {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                _this.hideModal();
            });
        });
    };
    TCAttachmentUpload.prototype.hideModal = function () {
        this.uploadForm.reset();
        this.modal.classList.remove('is-active');
    };
    TCAttachmentUpload.prototype.onFileSelected = function () {
        var _this = this;
        if (this.fileField.files) {
            var file = this.fileField.files[0];
            // Automatically set file name
            var split = file.name.lastIndexOf('.');
            if (split > 0) {
                this.modalNameField.value = file.name.substring(0, file.name.lastIndexOf('.'));
            }
            else {
                this.modalNameField.value = file.name;
            }
            this.modal.classList.add('is-active');
            setTimeout(function () {
                _this.modalNameField.focus();
            });
        }
    };
    TCAttachmentUpload.prototype.onModalFormSubmit = function () {
        var _this = this;
        this.nameField.value = this.modalNameField.value;
        this.modalSubmitButton.classList.add('is-loading');
        setTimeout(function () {
            _this.uploadForm.submit();
        });
    };
    return TCAttachmentUpload;
}(Lib));
export default TCAttachmentUpload;
